import { cn } from "@tine/designsystem-utils";
import type { PropsWithChildren } from "react";

type PriceBombProps = {
   size: "small" | "large";
};

const PriceBomb = ({ size, children }: PropsWithChildren<PriceBombProps>) => {
   const priceBombClasses =
      "flex aspect-square rounded-[50%] absolute bg-promotion text-base-0 font-semibold text-center justify-center items-center cursor-default";

   const priceBombSize = {
      small: "w-[36%] max-w-24 bottom-5 left-[10%] p-1 text-xs",
      large: "w-[30%] max-w-40 bottom-[10%] left-[10%] p-5 text-2xl"
   }[size];

   return <div className={cn(priceBombClasses, priceBombSize)}>{children}</div>;
};

export default PriceBomb;
